import moment from "moment";
import getSymbolFromCurrency from 'currency-symbol-map';

function CurrencyFormatter(value, locale, currency) {
    // later switch to session storage
    return value.toLocaleString(locale ? locale : "en-US", {
        style: "currency",
        currency: currency ? currency : "USD",
    });
}

// const getCurrency = () => {
//     return localStorage.getItem("Currency") ? localStorage.getItem("Currency") : "₹";
// };

const getCurrency = () => {
    const currencyCode = localStorage.getItem("Currency") || "INR"; // use currency code like "USD", "INR", "EUR"
    const symbol = getSymbolFromCurrency(currencyCode);
    return symbol || "₹"; // fallback if not found
  };


function TimeFormatter(value, locale) {
    if (!value) return 'Invalid time';

    // Combine with an arbitrary date (e.g., Jan 1, 1970)
    const combined = `1970-01-01T${value}:00`; // add seconds to make it complete

    const date = new Date(combined);

    // Check if it's a valid date
    if (isNaN(date.getTime())) return 'Invalid time';

    let time = date.toLocaleTimeString(locale || "en-US", {
        hour: '2-digit',
        minute: '2-digit',
    });

    return time;
}

function DateFormatter(value, locale) {
    // Get locale from localStorage
    const localeTime = localStorage.getItem("locale");

    // Use the passed locale, or the one from localStorage, or fallback to "en-US"
    const effectiveLocale = localeTime || "en-US";
    console.log('effectiveLocale::: ', effectiveLocale);

    // Format the date using the effective locale
    const formattedDate = new Date(value).toLocaleDateString(effectiveLocale);


    return formattedDate;
}


function convertToISO(dateInput) {
    // Check if dateInput is provided, otherwise use the current date
    const date = dateInput ? new Date(dateInput) : new Date();
    return date.toISOString(); // Outputs: "yyyy-MM-ddTHH:mm:ss.SSSZ"
}

export function formatDateByLocaleShort(dateInput, locales) {
    // Get locale from localStorage or fallback
    const locale = localStorage.getItem("locale") || "en-US";

    let date;

    // If input is in DD-MM-YYYY format, parse it manually
    if (typeof dateInput === 'string' && /^\d{2}-\d{2}-\d{4}$/.test(dateInput)) {
      const [day, month, year] = dateInput.split('-').map(Number);
      date = new Date(year, month - 1, day); // JS month is 0-indexed
    } else {
      date = new Date(dateInput); // Try standard Date parsing
    }

    if (isNaN(date)) return 'Invalid Date';

    const formatter = new Intl.DateTimeFormat(locale, {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });

    return formatter.format(date);
  }


function convertISOToDDMMYYYY(isoDate) {
    return moment(isoDate).format('DD-MM-YYYY');
}

function getEndTime(startTime, durationMinutes) {
    const [hours, minutes] = startTime.split(':').map(Number);
    const end = new Date(0, 0, 0, hours, minutes + durationMinutes);
    return `${end.getHours().toString().padStart(2, '0')}:${end.getMinutes().toString().padStart(2, '0')}`;
}

function resetToMidnightFormatted(date) {
  // const formattedDate = moment(date).format('YYYY-MM-DD'); // Formats to '2025-05-10'
  const newDate = new Date(date); // Converts to JS Date at midnight UTC
  newDate.setHours(0, 0, 0, 0);
  return newDate;
}

export function resetToMidnightFormatted1(date) {
  const formattedDate = moment(date).format('YYYY-MM-DD');
  const newDate = new Date(`${formattedDate}T11:30:00.000Z`);
  return newDate.toISOString();
}

export function formatDate(inputDate) {
    if (!inputDate) return '';

    const date = new Date(inputDate);
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // 0-based month
    const day = String(date.getUTCDate()).padStart(2, '0');

    return `${month}/${day}/${year}`;
}

 function getStartOfDay(today) {
  const newDate = new Date(today);
  newDate.setHours(0, 0, 0, 0);
  return newDate;
}


function formatTime(timeStr) {
  const [hour, minute] = timeStr.split(":");
  const date = new Date();
  date.setHours(+hour);
  date.setMinutes(+minute);

  return date.toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  });
}

export { CurrencyFormatter, getCurrency , DateFormatter,formatTime,getStartOfDay, TimeFormatter, convertToISO, convertISOToDDMMYYYY, getEndTime ,resetToMidnightFormatted };
